module.exports = __webpack_public_path__ + "e08e5d964947767aa048cbb6831818fe.png";